// extracted by mini-css-extract-plugin
export default {"theme-container":"Disclaimers_theme-container__mi6VB","container":"Disclaimers_container__69UUv","paragraph":"Disclaimers_paragraph__DUue8"};